"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class ScheduledObject {
    constructor(dymoUri, player) {
        this.dymoUri = dymoUri;
        this.player = player;
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store = this.player.getStore();
            this.parentUris = yield this.store.findAllParents(this.dymoUri);
        });
    }
    getUri() {
        return this.dymoUri;
    }
    getUris() {
        return [this.dymoUri].concat(this.parentUris);
    }
}
exports.ScheduledObject = ScheduledObject;
class DummyScheduledObject extends ScheduledObject {
    constructor(dymoUri, player, delay) {
        super(dymoUri, player);
        this.player.objectStarted(this);
        setTimeout(() => this.player.objectEnded(this), delay);
    }
    getParam(paramUri) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(0); //this.store.findParameterValue(this.dymoUri, paramUri);
        });
    }
    stop() {
        return Promise.resolve(this.player.objectEnded(this));
    }
}
exports.DummyScheduledObject = DummyScheduledObject;
class DymoScheduler {
}
exports.DymoScheduler = DymoScheduler;
class DummyScheduler extends DymoScheduler {
    constructor(delay) {
        super();
        this.delay = delay;
    }
    setListenerOrientation(posX, posY, posZ, forwX, forwY, forwZ) { }
    schedule(dymoUri, previousObject, player) {
        return new Promise(resolve => setTimeout(() => {
            console.log("scheduled", dymoUri);
            resolve(new DummyScheduledObject(dymoUri, player, this.delay));
        }, this.delay));
    }
    getAudioBank() {
        return null;
    }
}
exports.DummyScheduler = DummyScheduler;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-player/lib/scheduler.js
// module id = 646
// module chunks = 3